'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var React = require('react');
var types = require('./types-169d4b99.js');

var IMAGESERVICE = {
    CROP: {
        PADDING: 'c_pad',
        LIMIT: 'c_limit',
    },
    FULL_PATH_PREFIX: '/image/upload/',
    FORMAT: {
        PNG: 'f_png',
        WEB_P: 'f_webp',
        E_TRIM: 'e_trim',
    },
};

var EXTENSION = '.jpg';
var DEFAULT_IMAGE_SUFFIX = "-look" + EXTENSION;
var SIMPLE = 'simple';
var PRODUCT = 'product';
var imageRegex = /\/([sp]).*-([0-9]{2})([0-9]+)-((?:[0-9]+|z-)).*$/;
var createImagePath = function (resizeConfig) {
    var width = resizeConfig.width, height = resizeConfig.height, padding = resizeConfig.padding, quality = resizeConfig.quality, isTrimmed = resizeConfig.isTrimmed, paddingSize = resizeConfig.paddingSize, webP = resizeConfig.webP, isLimited = resizeConfig.isLimited;
    var sizeArray = [];
    var pathString = '';
    if (isTrimmed) {
        pathString += IMAGESERVICE.FORMAT.E_TRIM + "/";
    }
    if (webP) {
        pathString += IMAGESERVICE.FORMAT.WEB_P;
    }
    if (quality && quality <= 90) {
        pathString += "/q_" + quality;
    }
    if (padding) {
        sizeArray.push(IMAGESERVICE.CROP.PADDING);
    }
    if (isLimited) {
        pathString += IMAGESERVICE.CROP.LIMIT + "/";
    }
    if (width) {
        sizeArray.push("w_" + width);
    }
    if (height) {
        sizeArray.push("h_" + height);
    }
    if (paddingSize) {
        sizeArray.push("pd_" + paddingSize.top + "_" + paddingSize.right + "_" + paddingSize.bottom + "_" + paddingSize.left);
    }
    if (sizeArray.length > 0) {
        return pathString + "/" + sizeArray.join(',');
    }
    return "" + pathString;
};
var configureSize = createImagePath;
var resizeImage = function (url, resizeConfig) {
    if (url === '') {
        return '';
    }
    var _a = new URL(url), protocol = _a.protocol, hostname = _a.hostname, pathname = _a.pathname;
    var parts = pathname.match(imageRegex);
    if (parts) {
        var productType = parts[1], folder1 = parts[2], folder2 = parts[3], imageFileName = parts[4];
        var type = productType === 's' ? SIMPLE : PRODUCT;
        var newPath = "/" + type + "/" + folder1 + "/" + folder2 + "/" + imageFileName + EXTENSION;
        var fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
        fullPath += createImagePath(resizeConfig);
        fullPath += "/v" + (resizeConfig.version || 1);
        fullPath += newPath;
        fullPath = fullPath.replace(/\/\//g, '/');
        return new URL(fullPath, protocol + "//" + hostname).toString();
    }
    return "" + url + DEFAULT_IMAGE_SUFFIX;
};
var removeImageQualityParam = function (path) {
    var pattern = /\/q_\d+\//;
    return path.replace(pattern, '/');
};
var reformatImage = function (urlpath, staticHost, resizeConfig) {
    if (urlpath === '' || !staticHost) {
        return '';
    }
    var fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
    if (resizeConfig.isClubItem) {
        fullPath += "t_default.product_" + (resizeConfig.clubImageSize || 'small');
        fullPath += "/" + urlpath;
        return new URL(fullPath, staticHost).href;
    }
    fullPath += createImagePath(resizeConfig);
    fullPath += "/v" + (resizeConfig.version || 1);
    fullPath += "/" + urlpath;
    if (resizeConfig.excludeDefaultQuality) {
        fullPath = removeImageQualityParam(fullPath);
    }
    fullPath = fullPath.replace(/\/\//g, '/');
    return new URL(fullPath, staticHost).toString();
};
var changePreformattedImageProperties = function (preformattedUrl, resizeConfig, onError) {
    if (preformattedUrl === '') {
        return '';
    }
    try {
        var _a = new URL(preformattedUrl), protocol = _a.protocol, hostname = _a.hostname, pathname = _a.pathname;
        var cmsPreformattedPart = pathname.match(/\/cms\/.*/i);
        if (cmsPreformattedPart) {
            var fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
            fullPath += createImagePath(resizeConfig);
            fullPath += cmsPreformattedPart;
            fullPath = fullPath.replace(/\/\//g, '/');
            return new URL(fullPath, protocol + "//" + hostname).toString();
        }
        return "" + preformattedUrl + DEFAULT_IMAGE_SUFFIX;
    }
    catch (e) {
        if (onError) {
            onError(e);
        }
        return '';
    }
};
var getImageSizeInfo = function (screenWidth) {
    var screenHeight = Math.round((screenWidth * 4) / 3);
    var horizontalPadding = Math.round(screenWidth / 12.5);
    var verticalPadding = Math.round(screenHeight / 7.3529411765);
    return {
        padding: {
            top: verticalPadding,
            right: horizontalPadding,
            bottom: verticalPadding,
            left: horizontalPadding,
        },
        size: {
            width: screenWidth,
            height: screenHeight,
        },
    };
};
var calculateImageHeight = function (screenWidth) {
    var screenHeight = Math.round((screenWidth * 4) / 3);
    return screenHeight;
};
var preFormatImage = function (urlpath, staticHost, resizeConfig) {
    if (urlpath === '' || !staticHost) {
        return '';
    }
    var fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
    if (resizeConfig.isClubItem) {
        fullPath += "t_default.product_" + resizeConfig.clubImageSize;
        fullPath += "/" + urlpath;
        return new URL(fullPath, staticHost).href;
    }
    fullPath += createImagePath(resizeConfig);
    fullPath += "/v" + (resizeConfig.version || 1);
    fullPath += "/" + urlpath;
    fullPath = fullPath.replace(/\/\//g, '/');
    return new URL(fullPath, staticHost).href;
};
var formatImage = function (_a) {
    var src = _a.src, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, _b = _a.removeText, removeText = _b === void 0 ? false : _b, quality = _a.quality, paddingSize = _a.paddingSize, staticCmsHost = _a.staticCmsHost, _c = _a.padding, padding = _c === void 0 ? false : _c, _d = _a.isTrimmed, isTrimmed = _d === void 0 ? false : _d, _e = _a.isClubItem, isClubItem = _e === void 0 ? false : _e, _f = _a.clubImageSize, clubImageSize = _f === void 0 ? 'small' : _f;
    var resizeConfig = tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, (imageWidth ? { width: "" + imageWidth } : {})), (imageHeight ? { height: "" + imageHeight } : {})), (quality ? { quality: quality } : {})), (paddingSize ? { paddingSize: paddingSize } : {})), (isClubItem ? { clubImageSize: clubImageSize } : {})), { isClubItem: isClubItem,
        removeText: removeText,
        padding: padding,
        isTrimmed: isTrimmed,
        clubImageSize: clubImageSize });
    var webpSrc = preFormatImage(src, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign({}, resizeConfig), { webP: true }));
    var jpegSrc = preFormatImage(src, staticCmsHost, resizeConfig);
    return { webpSrc: webpSrc, jpegSrc: jpegSrc };
};

var addedPaddingTags = new Set([types.ProductImageTag.REGULAR]);
var excludeTrimmingTags = new Set([
    types.ProductImageTag.DETAIL,
    types.ProductImageTag.SIZE_RELATION,
    types.ProductImageTag.INFO_GRAPHIC,
]);
var getShortPath = function (src, urlKey) {
    if (urlKey === void 0) { urlKey = 'simple'; }
    if (urlKey === 'upload') {
        return "" + (src.split(urlKey)[1] || '');
    }
    return "" + urlKey + (src.split(urlKey)[1] || '');
};
var IMAGE_FORMATER_DEFAULT_OPTIONS = {
    webP: false,
    padding: true,
    isTrimmed: true,
};
var useImageTagFormatter = function (_a) {
    var tag = _a.tag, staticCmsHost = _a.staticCmsHost, options = _a.options, shouldRemoveText = _a.shouldRemoveText, baseUrlKey = _a.urlKey, baseVersion = _a.version;
    var _b = options !== null && options !== void 0 ? options : IMAGE_FORMATER_DEFAULT_OPTIONS, _c = _b.webP, webP = _c === void 0 ? false : _c, _d = _b.padding, padding = _d === void 0 ? true : _d, _e = _b.isTrimmed, isTrimmed = _e === void 0 ? true : _e, _f = _b.isLimited, isLimited = _f === void 0 ? false : _f;
    var resizeConfigurations = React.useMemo(function () { return ({
        padding: padding,
        removeText: shouldRemoveText,
        isTrimmed: isTrimmed && !excludeTrimmingTags.has(tag),
        isLimited: isLimited,
    }); }, [padding, shouldRemoveText, isTrimmed, isLimited, tag]);
    return React.useCallback(function (_a) {
        var src = _a.src, imageWidth = _a.imageWidth, imageSizeInfo = _a.imageSizeInfo, urlKey = _a.urlKey, version = _a.version, isClubItem = _a.isClubItem;
        var isImageWithPadding = addedPaddingTags.has(tag);
        var path = src;
        if (path.startsWith('http')) {
            path = getShortPath(path, urlKey || baseUrlKey);
        }
        var desiredImageWidth = imageWidth;
        var sizeInfo = imageSizeInfo || getImageSizeInfo(desiredImageWidth);
        var paddingSize = isImageWithPadding ? sizeInfo.padding : undefined;
        var imageDimension = tslib_es6.__assign(tslib_es6.__assign({}, sizeInfo.size), { paddingSize: paddingSize });
        var webpSrc = reformatImage(path, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, resizeConfigurations), imageDimension), { isClubItem: isClubItem, version: version || baseVersion, webP: webP }));
        var jpegSrc = reformatImage(path, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, resizeConfigurations), imageDimension), { isClubItem: isClubItem }));
        return { webpSrc: webpSrc, jpegSrc: jpegSrc };
    }, [tag, staticCmsHost, resizeConfigurations, webP, baseUrlKey, baseVersion]);
};

exports.calculateImageHeight = calculateImageHeight;
exports.changePreformattedImageProperties = changePreformattedImageProperties;
exports.configureSize = configureSize;
exports.createImagePath = createImagePath;
exports.excludeTrimmingTags = excludeTrimmingTags;
exports.formatImage = formatImage;
exports.getImageSizeInfo = getImageSizeInfo;
exports.getShortPath = getShortPath;
exports.preFormatImage = preFormatImage;
exports.reformatImage = reformatImage;
exports.resizeImage = resizeImage;
exports.useImageTagFormatter = useImageTagFormatter;
//# sourceMappingURL=useImageTagFormatter-f52f46f2.js.map
